import { Card } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { numberWithCommas } from 'utils/NumberCommaSeprator';
import { LoadingAnimation } from 'components/common';

const CardContainer = styled(Card)`
	height: 100%;
	display: flex;
	align-items: center;
	text-align: center;
	justify-content: center;
`;

const CountNumber = styled.span`
	font-size: 40px;
	font-weight: 500;
	font-family: 'Montserrat';
`;

function TotalProjects({ projects_count, isLoading }) {
	console.log('PC', projects_count);
	const totalProjects = projects_count?.total_projects || 0;
	return (
		<CardContainer>
			{isLoading ? (
				<LoadingAnimation visible={isLoading} animationID="TotalProjects" />
			) : (
				<>
					<CountNumber>{numberWithCommas(totalProjects)}</CountNumber>
					<p>Total Projects Created</p>
				</>
			)}
		</CardContainer>
	);
}

TotalProjects.propTypes = {
	projects_count: PropTypes.object,
	isLoading: PropTypes.bool,
};

export default TotalProjects;
